const ROLE_STYLES = {
  super_admin: "bg-purple-500/10 text-purple-600 border-purple-500/20",
  manager: "bg-blue-500/10 text-blue-600 border-blue-500/20",
  office: "bg-indigo-500/10 text-indigo-600 border-indigo-500/20",
  engineer: "bg-green-500/10 text-green-700 border-green-500/20",
};

const ROLE_LABELS = {
  super_admin: "Super Admin",
  manager: "Manager",
  office: "Office",
  engineer: "Engineer",
};

export default function RoleBadge({ role }) {
  const cls = ROLE_STYLES[role] || "bg-muted text-muted-foreground border-border";
  return (
    <span
      data-testid={`role-badge-${role}`}
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium border ${cls}`}
    >
      {ROLE_LABELS[role] || role}
    </span>
  );
}
